import { NgTemplateOutlet } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    input,
    model,
    TemplateRef,
    ViewEncapsulation,
} from "@angular/core";
import { CerrixToggleCardComponent } from "@app/shared/atoms/cerrix-toggle-card/cerrix-toggle-card.component";

export interface CerrixCardToggleOption {
    label: string;
    value: string;
    description?: string;

    // Free-form passthrough so a consumer's `cardContent` template can access its own
    // original data for the option without this molecule needing to know its shape.
    data?: unknown;
}

@Component({
    selector: "app-cerrix-card-toggle-group",
    templateUrl: "./cerrix-card-toggle-group.component.html",
    styleUrl: "./cerrix-card-toggle-group.component.scss",
    standalone: true,
    imports: [CerrixToggleCardComponent, NgTemplateOutlet],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixCardToggleGroupComponent {
    readonly options = input<CerrixCardToggleOption[]>([]);
    readonly selectedValue = model<string>();

    @ContentChild("cardContent")
    cardContentTemplate?: TemplateRef<{ $implicit: CerrixCardToggleOption }>;

    onOptionClick(option: CerrixCardToggleOption): void {
        this.selectedValue.set(option.value);
    }
}
